import { Department } from "../../../api/clinic.types";
import { ClinicDeparmentsAction } from "./clinic.departments.types";

export const clinicDepartmentsRequest = (): ClinicDeparmentsAction => ({ type: 'CLINIC_DEPARMENTS_REQUEST' } as const)

export const clinicDepartmentsSuccess = (deparments: Department[]): ClinicDeparmentsAction => ({ type: 'CLINIC_DEPARMENTS_SUCCESS', params: deparments } as const)

export const clinicDepartmentsFailure = (error?: any) => ({ type: 'CLINIC_DEPARMENTS_FAILURE' } as const)